import React from 'react';
import { personal, hero } from '../data';
import './Hero.css';

export default function Hero() {
  return (
    <section className="hero" id="top" data-scene="sitting-rock">
      <div className="hero__inner">
        <div className="hero__copy">
          <h1 className="hero__title">
            Hi, I’m {personal.name}.
          </h1>
          <p className="hero__intro">{hero.intro}</p>
          <p className="hero__recent">{hero.recent}</p>
          <p className="hero__recent">
            {hero.cards.before}
            <a className="hero__link" href={hero.cards.url} target="_blank" rel="noreferrer">{hero.cards.label}</a>.
          </p>
          <div className="hero__actions">
            <a className="btn btn--solid" href="#experience">See my experience</a>
            <a className="btn btn--line" href={personal.resumeUrl} target="_blank" rel="noreferrer">Résumé</a>
          </div>
        </div>
      </div>
    </section>
  );
}
